/*import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

const getCachedRssFeeds = httpsCallable(functions, 'getCachedRssFeeds');

async function loadFeed(feedId = 'nytimes') {
  try {
    const res = await getCachedRssFeeds({ feedId });
    setTopics(res.data.items);
  } catch (err) {
    console.error('Failed to load RSS feed:', err.message);
  }
}


import { getFirestore, doc, onSnapshot } from 'firebase/firestore';
const db = getFirestore();

useEffect(() => {
  const unsub = onSnapshot(doc(db, 'cachedFeeds', feedId), snapshot => {
    if (snapshot.exists()) {
      const data = snapshot.data();
      setTopics(data.items);
      setLastUpdated(data.lastUpdated);
    }
  });
  return unsub;
}, [feedId]);*/


import React, { useEffect, useState } from 'react';
import { storage, firestore, auth }  from "../../firebase/firebase.js";
import { getFirestore, collection, getDocs } from 'firebase/firestore';

export async function getItemsByFeedTitleKeyword(keyword) {
  const snap = await getDocs(collection(firestore, 'cachedFeeds'));

  const results = [];
  const lowerKeyword = keyword.toLowerCase();

  snap.forEach(doc => {
    const data = doc.data();
    if (data.feedTitle?.toLowerCase().includes(lowerKeyword)) {
      const feedItems = (data.items || []).map(item => ({
        ...item,
        feedId: doc.id,
        feedTitle: data.feedTitle,
      }));
      results.push(...feedItems);
    }
  });

  return results.sort((a, b) => new Date(b.date) - new Date(a.date));
}

/**
 * Returns all items from feeds whose title includes any keyword in the list.
 * @param {string[]} keywords - Array of keywords to match in feed titles.
 * @param {number} limit - Max number of results to return.
 */
export async function getItemsByFeedTitleKeywords(keywords = [], limit = 50) {
  const snap = await getDocs(collection(firestore, 'cachedFeeds'));
  const results = [];

  const lowerKeywords = keywords.map(k => k.toLowerCase());

  snap.forEach(doc => {
    const data = doc.data();
    const title = data.feedTitle?.toLowerCase() || '';

    const matchesKeyword = lowerKeywords.some(k => title.includes(k));
    if (matchesKeyword) {
      const items = (data.items || []).map(item => ({
        ...item,
        feedId: doc.id,
        feedTitle: data.feedTitle,
      }));
      results.push(...items);
    }
  });

  // Sort by date and apply limit
  return results
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, limit);
}

